import styled from 'styled-components'

export const DisclaimerText = styled.div`
  font-size: var(--font-minuscule);
  margin-bottom: var(--size-large);
`
